import React from "react";
import MetaData from "../../components/layout/MetaData";
import { useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Breadcrumb from "../../components/layout/Breadcrumb/breadcrumbCart";
import { Image } from "react-bootstrap";
import SelectAll from "./SelectAll";
// import ManualEntry from "./ManualEntry";
import Message from "../../components/Message";

// Redux
import { useDispatch } from "react-redux";
import { setCartItem } from "../../redux/features/cartSlice";
import { removeCartItem } from "../../redux/features/cartSlice";

const Cart = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { cartItems } = useSelector((state) => state.cart);

  const removeCartItemHandler = (id) => {
    dispatch(removeCartItem(id));
  };

  const handleCheckout = () => {
    navigate("/shipping");
  };

  const increseQty = (item, quantity) => {
    const moq = item?.multipleOrderQuantity || 1;
    const newQty = quantity + moq;

    setItemToCart(item, newQty);
  };

  const decreseQty = (item, quantity) => {
    const moq = item?.multipleOrderQuantity || 1;
    const newQty = quantity - moq;

    if (newQty < moq) return;

    setItemToCart(item, newQty);
  };

  /**
   * 处理键盘输入数量
   * @param {Object} item - 商品项
   * @param {Event} e - 输入事件
   */
  const handleQuantityChange = (item, e) => {
    let value = parseInt(e.target.value);
    const stock = parseInt(item?.stock);
    const moq = item?.multipleOrderQuantity || 1;

    if (isNaN(value) || value < moq) {
      setItemToCart(item, moq);
    } else {
      // 向上取整到最近的倍数
      value = Math.ceil(value / moq) * moq;
      setItemToCart(item, value);
    }
  };

  const setItemToCart = (item, newQty) => {
    const cartItem = {
      product: item?.product,
      name: item?.name,
      price: item?.price,
      image: item?.image,
      stock: item?.stock,
      multipleOrderQuantity: item?.multipleOrderQuantity || 1,
      quantity: newQty,
    };

    dispatch(setCartItem(cartItem));
  };

  return (
    <>
      <article className="container mx-auto p-1">
        <MetaData title={"Your Cart"} />
        <Breadcrumb />

        {cartItems?.length === 0 ? (
          <>
            <Message style={{ textAlign: "center" }}>
              <h1 style={{ textAlign: "center" }}>Your Cart is Empty</h1>
              <Link
                style={{ textAlign: "center", display: "block" }}
                to="/products"
              >
                Go Back
              </Link>
            </Message>
          </>
        ) : (
          <>
            <form className="mt-6 flex flex-col space-y-6 justify-center">
              {/* <ManualEntry /> */}
              <SelectAll />
              <section className="bg-white p-4 rounded-lg shadow">
                <div className="flex flex-row items-center justify-between border-b pb-2">
                  <div className="flex justify-start items-center text-center w-1/5">
                    <strong>Product Details</strong>
                  </div>
                  <div className="flex justify-center items-center w-1/5">
                    <strong>Qty</strong>
                  </div>
                  <div className="flex justify-center items-center w-2/5">
                    <strong>Unit Price</strong>
                  </div>
                  <div className="flex justify-center items-center w-2/5">
                    <strong>Extended Price</strong>
                  </div>
                  <div className="flex justify-center items-center w-0/5">
                    <strong>Remove</strong>
                  </div>
                </div>
                {cartItems?.map((item) => (
                  <div className="flex flex-row items-center justify-between border-b pb-2 mt-4">
                    <div className="flex flex-col items-center w-1/5">
                      <Image
                        src={item?.image}
                        className="h-16 w-16 object-cover rounded-md"
                        alt="product-image"
                      />
                      <Link
                        to={`/products/${item.product}`}
                        className="text-blue-500 hover:text-blue-600 mt-2"
                      >
                        {item?.name}
                      </Link>
                    </div>

                    <div className="flex items-center justify-center w-2/5">
                      <button
                        type="button"
                        onClick={() => decreseQty(item, item?.quantity)}
                        className="bg-red-500 text-white font-bold py-1 px-3 rounded hover:bg-red-600 max-w-10"
                      >
                        -
                      </button>
                      <input
                        type="number"
                        step={item?.multipleOrderQuantity || 1}
                        value={item?.quantity}
                        onChange={(e) => handleQuantityChange(item, e)}
                        className="text-center w-1/5 py-1 border border-gray-300 rounded justify-center items-center max-w-16"
                        min={item?.multipleOrderQuantity || 1}
                      />
                      <button
                        type="button"
                        onClick={() => increseQty(item, item?.quantity)}
                        className="bg-blue-500 text-white font-bold py-1 px-3 rounded hover:bg-blue-600 max-w-10"
                      >
                        +
                      </button>
                    </div>

                    <div className="flex items-center justify-center w-3/5 text-center">
                      <span className="text-lg text-blue-600 font-semibold">
                        ${item?.price.toFixed(2)}
                      </span>
                    </div>

                    <div className="flex items-center justify-center w-3/5">
                      <span className="text-lg text-blue-600 font-semibold">
                        ${(item?.price * item?.quantity).toFixed(2)}
                      </span>
                    </div>

                    <div className="flex items-center justify-center w-0/1">
                      <button
                        onClick={() => removeCartItemHandler(item?.product)}
                        className="text-red-500 hover:text-red-700"
                      >
                        <i className="fas fa-trash"></i> Remove
                      </button>
                    </div>
                  </div>
                ))}

                <div className="text-right mt-4">
                  <h4 className="font-semibold">
                    Subtotal:{"   "}
                    <span className="text-blue-600">
                      $
                      {cartItems
                        ?.reduce(
                          (acc, item) => acc + item?.quantity * item.price,
                          0
                        )
                        .toFixed(2)}
                    </span>
                  </h4>
                  <button
                    type="submit"
                    onClick={handleCheckout}
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded shadow mt-3"
                  >
                    Checkout
                  </button>
                </div>
              </section>
            </form>

            <aside className="mt-6 bg-blue-100 p-4 rounded-lg shadow">
              <div className="flex items-center space-x-2">
                <i className="fas fa-lock text-blue-500"></i>
                <h3 className="text-lg font-semibold">Secure Checkout</h3>
                <p>Your data will be encrypted and transmitted securely.</p>
              </div>
              <button
                type="button"
                onClick={handleCheckout}
                className="mt-4 bg-blue-500 hover:bg-blue-700   text-white font-bold py-2 px-4 rounded w-full"
              >
                Checkout
              </button>
            </aside>
          </>
        )}
      </article>
    </>
  );
};

export default Cart;
